// Single source of truth for SayIt pricing & checkout.
// One global price, one worldwide Lemon Squeezy checkout.
// Live Mode checkout URL (approved production link).
export const CHECKOUT_URL =
  "https://sayittools.lemonsqueezy.com/checkout/buy/aab38066-5a66-40fe-a4b6-b0f70c82d8b5";

export const PRICE_LABEL = "US$2.99";
